import { EventEmitter, Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class ScrollService {
    public triggeredScroll = new EventEmitter();

    private pageYOffset = 0;

    public constructor() {}

    public onScroll(): void {
        this.triggeredScroll.emit();
    }

    public getPageYOffset(): number {
        return this.pageYOffset;
    }

    public setPageYOffset(offset: number): void {
        this.pageYOffset = offset;
    }
}
